<div class="dialog-container">
    <div class="dialog-title-block">
        <h2>Edit Implant Details</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <form>
        <div class="dialog-content-block p-3">
            <div class="form-group mb-4">
                <h6 class="text-start text-dark">Product</h6>
                <input type="text" name="product_name" [ngModel]="implantDetails?.product_name">
            </div>
            <div class="d-flex gap-5 w-100">
                <div class="w-50 d-flex flex-column gap-3">
                    <div class="form-group">
                        <h6 class="text-start text-dark">Store</h6>
                        <input type="text" name="store_name" [ngModel]="implantDetails?.store_name">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Batch Number</h6>
                        <input type="text" name="batch_no" [ngModel]="implantDetails?.batch_no">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Expiry Date</h6>
                        <input type="date" name="expiry_date" [ngModel]="implantDetails?.expiry_date">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Product Code</h6>
                        <input type="text" name="product_code" [ngModel]="implantDetails?.product_code">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">RFID</h6>
                        <input type="text" name="rfid" [ngModel]="implantDetails?.rfid">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Product Category</h6>
                        <input type="text" name="product_category" [ngModel]="implantDetails?.product_category">
                    </div>
                </div>
                <div class="w-50 d-flex flex-column gap-3">
                    <div class="form-group">
                        <h6 class="text-start text-dark">Cabinet</h6>
                        <input type="text" name="cabinet_name" [ngModel]="implantDetails?.cabinet_name">
                        <h6 *ngIf="!implantDetails?.cabinet_name" class="text-start text-dark">At Store</h6>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Device Id</h6>
                        <input type="text" name="device_id" [ngModel]="implantDetails?.device_id">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Body Type</h6>
                        <input type="text" name="body_type" [ngModel]="implantDetails?.body_type">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Implant Type</h6>
                        <input type="text" name="implant_type" [ngModel]="implantDetails?.implant_type">
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Rate</h6>
                        <input type="text" name="rate" [ngModel]="implantDetails?.rate">
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <button (click)="onClose()">Cancel</button>
            <button>Update</button>
        </div>
    </form>
</div>

